export default "/wp-content/themes/onnit/script/cart/dist/hydratechInstantOverride-71634e7e.png";